module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDraaiboekE2A637.666d7d51.png";